export const checkoutInitialValues = {
  name: "",
  phone: "",
  location: "",
  address: "",
};

export const registerInitialValues = {
  name: "",
  email: "",
  password: "",
};

export const loginInitialValues = {
  email: "",
  password: "",
};

export const forgotPasswordInitialValues = {
  email: "",
};
